import { Component, inject, Input, OnInit } from '@angular/core';

import { IShipping } from '../../interfaces/shipping.interface';
import { ShippingStatusPipe } from '../../pipes/shipping-status.pipe';
import { ShippingStopKindPipe } from '../../pipes/shipping-stop-kind.pipe';
import { ProofEvidenceService } from '../../services/proof-evidence.service';

@Component({
  selector: '`peca-shipping-concluded`',
  templateUrl: './shipping-concluded.component.html',
  styleUrl: './shipping-concluded.component.scss',
  imports: [ShippingStatusPipe, ShippingStopKindPipe],
})
export class ShippingConcludedComponent implements OnInit {
  @Input()
  shipping!: IShipping;

  proofEvidenceService = inject(ProofEvidenceService);
  proofUrls: Record<number, string> = {};

  ngOnInit() {
    for (const stop of this.shipping?.stops ?? []) {
      if (stop.finalized && stop.proofUploadId && !this.proofUrls[stop.index]) {
        this.proofUrls[stop.index] = this.proofEvidenceService.proofContentUrl(stop.proofUploadId);
      }
    }
  }

  proofUrlFor(index: number): string | null {
    return this.proofUrls[index] ?? null;
  }
}
